<app-core-field
  class="core-field-component"
  [ngClass]="{'is-appcc': !!task?.id_appcc}"
  [menu]="menu"
  [task]="task"
  [field]="field"
  (openImage)="openImage.emit()"
  (takeImage)="takeImage.emit()"
>

  <ng-container field-label>

    @if (!field.no_necesario) {

      @if (type === fieldTypes.rate) {

        <app-yu-rating
          [showNumber]="false"
          [(value)]="field.value"
          (valueChange)="valueChange.emit()"
        ></app-yu-rating>

      }

      @if (type === fieldTypes.input && !task?.id_appcc) {

        <yu-textarea
          placeholder="..."
          [rows]="3"
          [disabled]="!!(task?.cerrado || task?.seguidor)"
          [(value)]="field.value"
          (yuBlur)="valueChange.emit()"
        ></yu-textarea>

      }

    }

  </ng-container>

  <ng-container field-note>

    @if (type === fieldTypes.check) {

      <yu-checkbox
        style="width: auto"
        [disabled]="task?.cerrado || task?.superviso || task?.seguidor || field.revisado"
        [(value)]="field.value"
        (valueChange)="valueChange.emit()"
      ></yu-checkbox>

      @if (task?.superviso) {
        <yu-checkbox
          style="width: auto"
          [(value)]="field.revisado_bool"
          (valueChange)="valueChange.emit()"
        ></yu-checkbox>
      }

    }

    @if (type === fieldTypes.select) {

      <ion-radio-group [(ngModel)]="field.value" (ngModelChange)="valueChange.emit()">
        <ion-radio value="1">{{ 'ITEMS.TASKS.YES' | translate }}</ion-radio>
        <ion-radio value="2">{{ 'ITEMS.TASKS.NO' | translate }}</ion-radio>
      </ion-radio-group>

    }

    @if (type === fieldTypes.input && !!task?.id_appcc) {

      <yu-input
        placeholder="..."
        [disabled]="!!(task?.cerrado || task?.seguidor)"
        [(value)]="field.value"
        (yuBlur)="valueChange.emit()"
      ></yu-input>

    }

  </ng-container>

</app-core-field>
